module.exports = __webpack_public_path__ + "70a5239a56512a0c1b74035e1de9992d.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/saaspass-vpn/integration/integration.html
// module id = 1553
// module chunks = 0